var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownloadOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.15081 8.24074C6.73148 7.88132 6.10018 7.92988 5.74076 8.34921C5.38134 8.76853 5.4299 9.39983 5.84923 9.75926L10 13.3171L14.1508 9.75926C14.5701 9.39983 14.6187 8.76853 14.2593 8.34921C13.8999 7.92988 13.2686 7.88132 12.8492 8.24074L11 9.82578V4C11 3.44771 10.5523 3 10 3C9.44773 3 9.00002 3.44771 9.00002 4V9.82578L7.15081 8.24074ZM4 15C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15H4Z",
  fill: "currentColor"
})));
export { SvgDownloadOutline20 as ReactComponent };